import { useEffect, useState } from "react";
import { getInboxList } from "../../../api/getApi";
import NotFound from "../../../components/ProgressBlock/NotFound";
import InboxItem from "../InboxItem";
import LoadingBlock from "../../../components/Loading/LoadingBlock";
import LoadingInbox from "../../../components/Loading/LoadingInbox";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

const InboxList = ({ isInbox }) => {
  const [inboxList, setInboxList] = useState([]);
  const [apiCalling, setApiCalling] = useState(true);

  const globalLoading = useSelector((state) => state.isLoaderStatus);

  const location = useLocation();

  // useEffect(() => {
  //   setApiCalling(true);
  //   getInboxList()
  //     .then((data) => {
  //       setInboxList(data.data);
  //     })
  //     .finally(() => {
  //       setApiCalling(false);
  //     });
  // }, [location.pathname]);

  return (
    <LoadingInbox commonLoading={globalLoading}>
      {inboxList.length === 0 ? (
        <NotFound />
      ) : (
        inboxList.map((item, index) => {
          return <InboxItem isInbox key={index} data={item} />;
        })
      )}
    </LoadingInbox>
  );
};

export default InboxList;
